<template>
    <div class="address-content">
        <div
            class="row no-gutters justify-content-start align-items-center common-step-head"
        >
            <img src="../assets/images/step_icon.png" alt="step" />
            <p>{{ $t('stepFour.title') }}</p>
        </div>
        <div class="progress custom-progress">
            <div
                class="progress-bar"
                role="progressbar"
                style="width: 100%"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <!-- 商品 & 地址表单 begin -->
        <div class="row justify-content-between no-gutters">
            <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div class="show-pc">
                    <div class="goods-info">
                        <img
                            :src="$store.state.giftImage"
                            :alt="$store.state.giftName"
                        />
                        <div class="good-info-mask">
                            <p>{{ $t('stepFour.desp') }}</p>
                            <span>{{ $store.state.giftName }} </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
                <div class="left-form-distance common-step-padding">
                    <form action="">
                        <!-- 姓名 -->
                        <div class="form-group custom-input">
                            <label for="name"
                                >1. {{ $t('stepFour.fullName') }}</label
                            >
                            <input
                                type="text"
                                id="name"
                                :class="showNameError ? 'error-border' : ''"
                                :placeholder="
                                    $t('stepFour.fullNamePlaceholder')
                                "
                                v-model="$store.state.deliverName"
                                @focus="changeName()"
                            />
                            <span class="error-font" v-if="showNameError">{{
                                $t('stepFour.fullNameErrMsg')
                            }}</span>
                        </div>
                        <!-- 手机 -->
                        <div class="form-group custom-input">
                            <label for="phone"
                                >2. {{ $t('stepFour.phone') }}</label
                            >
                            <input
                                type="email"
                                id="phone"
                                :class="showPhoneError ? 'error-border' : ''"
                                :placeholder="$t('stepFour.phonePlaceholder')"
                                v-model="$store.state.deliverPhone"
                                @focus="changePhone()"
                            />
                            <span class="error-font" v-if="showPhoneError">{{
                                $t('stepFour.phoneErrMsg')
                            }}</span>
                        </div>
                        <!-- 邮箱 -->
                        <div class="form-group custom-input">
                            <label for="email"
                                >3. {{ $t('stepFour.email') }}</label
                            >
                            <input
                                type="email"
                                id="email"
                                :class="showEmailError ? 'error-border' : ''"
                                :placeholder="$t('stepFour.emailPlaceholder')"
                                v-model="$store.state.deliverEmail"
                                @focus="changeEmail()"
                            />
                            <span class="error-font" v-if="showEmailError">{{
                                $t('stepFour.emailErrMsg')
                            }}</span>
                        </div>
                        <!-- 地址 -->
                        <div class="form-group custom-input">
                            <label for="address"
                                >4. {{ $t('stepFour.address') }}</label
                            >
                            <input
                                class="mb-4"
                                type="text"
                                id="street_address"
                                :class="showStreetError ? 'error-border' : ''"
                                :placeholder="$t('stepFour.streetPlaceholder')"
                                v-model="$store.state.deliverStreet"
                                @focus="changeStreet()"
                            />
                            <input
                                class="mb-4"
                                type="text"
                                id="apartment"
                                :class="
                                    showApartmentError ? 'error-border' : ''
                                "
                                :placeholder="
                                    $t('stepFour.apartmentPlaceholder')
                                "
                                v-model="$store.state.deliverApartment"
                                @focus="changeApartment()"
                            />
                            <input
                                class="mb-4"
                                type="text"
                                id="city"
                                :class="showCityError ? 'error-border' : ''"
                                :placeholder="$t('stepFour.cityPlaceholder')"
                                v-model="$store.state.deliverCity"
                                @focus="changeCity()"
                            />
                            <div class="d-flex">
                                <!-- 国家地区两级联动插件 -->
                                <country-select
                                    class="mr-4"
                                    :class="
                                        showCountryError ? 'error-border' : ''
                                    "
                                    v-model="$store.state.deliverCountry"
                                    :country="$store.state.deliverCountry"
                                    topCountry="US"
                                    :countryName="true"
                                    :placeholder="$t('stepFour.countryPlaceholder')"
                                    @change="changeCountry()"
                                />
                                <region-select
                                    :class="
                                        showRegionError ? 'error-border' : ''
                                    "
                                    v-model="$store.state.deliverRegion"
                                    :country="$store.state.deliverCountry"
                                    :region="$store.state.deliverRegion"
                                    :countryName="true"
                                    :regionName="true"
                                    defaultRegion=""
                                    :placeholder="$t('stepFour.regionPlaceholder')"
                                    @change="changeRegion()"
                                />
                            </div>
                            <!-- <input
                                type="text"
                                id="address"
                                :class="showAddressError?'error-border':''"
                                :placeholder="$t('stepFour.addressPlaceholder')"
                                v-model="$store.state.deliverAddress"
                                @focus="changeAddress()"
                            /> -->
                            <span
                                class="error-font"
                                v-if="
                                    showStreetError ||
                                    showApartmentError ||
                                    showCityError ||
                                    showRegionError ||
                                    showCountryError
                                "
                                >{{ $t('stepFour.addressErrMsg') }}</span
                            >
                        </div>

                        <!-- post code  -->
                        <div class="form-group custom-input">
                            <label for="postcode"
                                >5. {{ $t('stepFour.postcode') }}</label
                            >
                            <input
                                type="text"
                                id="postcode"
                                :class="showPostError ? 'error-border' : ''"
                                :placeholder="
                                    $t('stepFour.postcodePlaceholder')
                                "
                                v-model="$store.state.deliverPostcode"
                                @focus="changePost()"
                            />
                            <span class="error-font" v-if="showPostError">{{
                                $t('stepFour.postcodeErrMsg')
                            }}</span>
                        </div>
                        <div class="row no-gutters justify-content-end">
                            <button
                                type="button"
                                class="common-comfirm-btn btn-width-100"
                                @click="comfirm()"
                            >
                                {{ $t('stepFour.btnComfirm') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- 商品 & 地址表单 end -->

        <!-- 重新选择礼物 弹框 -->
        <div class="modal-gift" v-if="isShowGiftModal">
            <div class="modal-gift-body">
                <div class="choose-content h-100">
                    <p>{{ $t('chooseGift.modalTitle') }}</p>
                    <div class="row">
                        <div
                            class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4 phone-goods"
                            v-for="(item, index) in $store.state.giftsList"
                            :class="item.stock_sn === 0 ? 'hidden' : ''"
                            :key="index"
                        >
                            <div class="goods-list">
                                <div class="goods-list-img">
                                    <img
                                        class="w-100 h-100"
                                        :src="item.cover"
                                        :alt="item.name"
                                    />
                                </div>
                                <p class="goods-list-title basic-font">
                                    {{ item.name }}
                                </p>
                                <div
                                    class="goods-list-btn row no-gutters justify-content-start"
                                >
                                    <button
                                        type="button"
                                        class="common-comfirm-btn comfirm-btn-hover"
                                        @click="
                                            chooseGift(
                                                item.id,
                                                item.name,
                                                item.kind,
                                                item.cover
                                            )
                                        "
                                    >
                                        {{ $t('chooseGift.btnWant') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--上拉分页组件 v-if="isScrollLodingShow" ref="infiniteLoading"-->
                    <div class="mt-4" v-if="isScrollLodingShow">
                        <infinite-loading
                            :distance="50"
                            throttleLimit="1000"
                            @infinite="infiniteHandler"
                        >
                            <!-- <div slot="spinner">Loading...</div> -->
                            <div slot="no-more">No more data</div>
                        </infinite-loading>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
export default {
    name: 'Address',
    data() {
        return {
            showNameError: false, // 错误提示
            showPhoneError: false,
            showEmailError: false,
            // showAddressError: false,
            showStreetError: false,
            showApartmentError: false,
            showCityError: false,
            showRegionError: false,
            showCountryError: false,
            showPostError: false,
            totalPage: 0,
            currentPage: 1,
            isScrollLodingShow: false,
            isShowGiftModal: false, // 是否显示重新选择礼物弹框
        };
    },
    components: {
        InfiniteLoading,
    },
    // computed: {
    //     showCountryError(){
    //         return this.$store.state.deliverCountry == ''? true:false;
    //     }
    // },
    methods: {
        // input 聚焦 隐藏相对应的错误
        changeName() {
            this.showNameError = false;
        },
        changePhone() {
            this.showPhoneError = false;
        },
        // changeAddress() {
        //     this.showAddressError = false
        // },
        changeStreet() {
            this.showStreetError = false;
        },
        changeApartment() {
            this.showApartmentError = false;
        },
        changeCity() {
            this.showCityError = false;
        },
        changeRegion() {
            // change事件不生效
            this.showRegionError =
                this.$store.state.deliverRegion == '' ? true : false;
        },
        changeCountry() {
            // change事件不生效
            // console.log('changeCountry', this.$store.state.deliverCountry);
            this.showCountryError =
                this.$store.state.deliverCountry == '' ? true : false;
        },
        changeEmail() {
            this.showEmailError = false;
        },
        changePost() {
            this.showPostError = false;
        },
        // comfirm按钮事件
        comfirm() {
            if (this.$store.state.deliverCountry != '') {
                this.showCountryError = false;
            }
            if (this.$store.state.deliverRegion != '') {
                this.showRegionError = false;
            }
            let regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; // 邮箱正则
            if (this.$store.state.deliverName == '') {
                this.showNameError = true;
            } else if (this.$store.state.deliverPhone == '') {
                this.showPhoneError = true;
            } else if (
                this.$store.state.deliverEmail == '' ||
                !regEmail.test(this.$store.state.deliverEmail)
            ) {
                this.showEmailError = true;
            } else if (this.$store.state.deliverStreet == '') {
                this.showStreetError = true;
            } else if (this.$store.state.deliverApartment == '') {
                this.showApartmentError = true;
            } else if (this.$store.state.deliverCity == '') {
                this.showCityError = true;
            } else if (this.$store.state.deliverCountry == '') {
                this.showCountryError = true;
            } else if (this.$store.state.deliverRegion == '') {
                this.showRegionError = true;
            }
            // else if (this.$store.state.deliverAddress == '') {
            //     this.showAddressError = true
            // }
            else if (this.$store.state.deliverPostcode == '') {
                this.showPostError = true;
            } else {
                // 请求API 成功后跳转 complete页面  根据虚拟和实物 跳转页面显示不同内容
                let params = {
                    jid: this.$store.state.giftOrderID,
                    'order[amazon_order_id]': this.$store.state.amazonOrderID,
                    'order[shop_id]': this.$store.state.shopID,
                    'order[gift_id]': this.$store.state.giftID,
                    'order[name]': this.$store.state.name,
                    'order[email]': this.$store.state.email,
                    'orders_questionnaire[sex]': this.$store.state.stepOne.sex,
                    'orders_questionnaire[age]': this.$store.state.stepOne.age,
                    'orders_questionnaire[reason]': this.$store.state.stepOne
                        .reason,
                    'orders_questionnaire[reason_deatail]': this.$store.state
                        .stepOne.otherReason,
                    'orders_questionnaire[rating]': this.$store.state.stepTwo
                        .starNum,
                    'orders_questionnaire[comment]': this.$store.state.stepTwo
                        .commentValue,
                    'order[deliver_name]': this.$store.state.deliverName,
                    'order[deliver_phone]': this.$store.state.deliverPhone,
                    'order[deliver_email]': this.$store.state.deliverEmail,
                    // 'order[deliver_address]': this.$store.state.deliverAddress,
                    'order[deliver_country]': this.$store.state.deliverCountry,
                    'order[deliver_region]': this.$store.state.deliverRegion,
                    'order[deliver_city]': this.$store.state.deliverCity,
                    'order[deliver_street]': this.$store.state.deliverStreet,
                    'order[deliver_address]': this.$store.state.deliverApartment,
                    'order[deliver_postcode]': this.$store.state
                        .deliverPostcode,
                };
                // console.info(params)

                this.getGiftInfo().then((hasStock) => {
                    // 判断礼物库存
                    if (hasStock) {
                        // 礼物有库存
                        this.$post(`/api/v1/orders`, params)
                            .then((data) => {
                                // console.log(data)
                                if (data.result.persisted) {
                                    this.$router.push({ path: '/complete' });
                                    // 初始化数据
                                    this.initData();
                                    this.initGiftsData();
                                }
                            })
                            .catch((err) => {
                                console.info(err);
                            });
                    }
                });
            }
        },
        // 判断选择的礼物是否有库存
        getGiftInfo() {
            let _this = this;
            return new Promise((reslove, reject) => {
                let shopID = _this.$store.state.shopID; // 店铺id
                let giftID = _this.$store.state.giftID; // 礼物id
                let giftName = _this.$store.state.giftName;
                let giftType = _this.$store.state.giftType;
                let giftImage = _this.$store.state.giftImage;
                let amazonOrderID = _this.$store.state.amazonOrderID; // 亚马逊订单id
                let giftOrderID = _this.$store.state.giftOrderID; // 礼物订单id
                _this
                    .$get(
                        `/api/v1/gifts/${shopID}/${giftID}/${amazonOrderID}/${giftOrderID}/query`
                    )
                    .then((data) => {
                        let hasStock = data.persisted;
                        if (!hasStock) {
                            // 无库存

                            // 初始化礼物列表数据
                            _this.initGiftsData();
                            // 获取礼物列表
                            _this.getGiftsList();
                            // 显示重新选择礼物弹框
                            _this.isShowGiftModal = true;
                        } else {
                            _this.isShowGiftModal = false;
                        }
                        reslove(hasStock);
                    })
                    .catch((err) => {
                        console.info(err);
                        if (err.status === 404) {
                            // 订单30分钟内未完成
                            // 重新确认选择礼品
                            _this
                                .putOrderInfo(
                                    giftID,
                                    giftName,
                                    giftType,
                                    giftImage
                                )
                                .then((jid) => {
                                    // console.info('jid=', jid)
                                    if (jid) {
                                        // 成功返回jid，则礼物有库存
                                        _this.$store.state.giftOrderID = jid;
                                    } else {
                                        // 初始化礼物列表数据
                                        _this.initGiftsData();
                                        // 获取礼物列表
                                        _this.getGiftsList();
                                        // 显示重新选择礼物弹框
                                        _this.isShowGiftModal = true;
                                    }
                                });
                        }
                        reject(err);
                    });
            });
        },
        // 初始化数据
        initData() {
            this.$store.state.name = '';
            this.$store.state.email = '';
            this.$store.state.amazonOrderID = null;
            this.$store.state.amazonProductASIN = '';
            this.$store.state.amazonProductName = '';
            this.$store.state.salesChannel = '';
            this.$store.state.shopID = null;
            // this.$store.state.giftType = null // Complete页面使用后再销毁
            this.$store.state.giftID = null;
            this.$store.state.giftOrderID = null;
            this.$store.state.giftName = '';
            this.$store.state.giftImage = '';
            this.$store.state.deliverName = '';
            this.$store.state.deliverPhone = '';
            // this.$store.state.deliverEmail = '' // Complete页面使用后再销毁
            // this.$store.state.deliverAddress = ''
            this.$store.state.deliverStreet = '';
            this.$store.state.deliverApartment = '';
            this.$store.state.deliverCity = '';
            this.$store.state.deliverRegion = '';
            this.$store.state.deliverCountry = '';
            this.$store.state.deliverPostcode = '';
            this.$store.state.stepOne = {
                sex: null,
                age: null,
                reason: null,
                otherReason: '',
                isDisabledInput: true,
                isDisabledBtnNext: true,
            };
            this.$store.state.stepTwo = {
                starNum: this.$store.state.stepTwo.starNum, // Complete页面使用后再销毁
                commentValue: '',
                isDisabledBtnNext: true,
            };
        },
        // 获取礼物列表
        getGiftsList() {
            let shopID = this.$store.state.shopID; // 店铺id
            let currentPage = this.currentPage;
            // console.info('shopID=', shopID, ',currentPage=', currentPage)
            this.$get(
                `/api/v1/shops/${shopID}/gifts?page=${currentPage}&&per=8`
            )
                .then((data) => {
                    let gifts = data.gifts;
                    this.totalPage = gifts.total_pages;
                    this.$store.commit('getGiftsListScroll', gifts.gifts);
                })
                .catch((err) => {
                    console.info(err);
                });
        },
        // 滚动分页，上拉无限加载
        infiniteHandler($state) {
            let shopID = this.$store.state.shopID; // 店铺id
            this.currentPage = this.currentPage + 1;
            // console.info('shopID=', shopID, ',currentPage=', this.currentPage)
            this.$get(
                `/api/v1/shops/${shopID}/gifts?page=${this.currentPage}&&per=8`
            )
                .then((data) => {
                    let gifts = data.gifts;
                    if (this.currentPage <= this.totalPage) {
                        this.$store.commit('getGiftsListScroll', gifts.gifts);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                })
                .catch((err) => {
                    console.info(err);
                });
        },
        // 重新选择礼物
        chooseGift(giftID, giftName, giftType, giftImage) {
            this.isShowGiftModal = true;
            // 确认选择礼品
            this.putOrderInfo(giftID, giftName, giftType, giftImage);
        },
        // 确认选择礼品
        putOrderInfo(giftID, giftName, giftType, giftImage) {
            return new Promise((reslove, reject) => {
                let shopID = this.$store.state.shopID; // 店铺id
                let amazonOrderID = this.$store.state.amazonOrderID; // 亚马逊订单id
                let jid = '';
                this.$put(`/api/v1/shops/${shopID}/gifts/${giftID}`, {
                    amazon_order_id: amazonOrderID,
                })
                    .then((data) => {
                        this.$store.state.giftID = giftID;
                        this.$store.state.giftName = giftName;
                        this.$store.state.giftType = giftType;
                        this.$store.state.giftImage = giftImage;
                        this.$store.state.giftOrderID = data.result.jid;
                        this.isShowGiftModal = false;
                        jid = data.result.jid;
                        reslove(jid);
                    })
                    .catch((err) => {
                        jid = '';
                        reslove(jid);
                        console.info(err);
                    });
            });
        },
        // 初始化礼物列表数据
        initGiftsData() {
            this.$store.commit('getGiftsList', []);
            this.$store.commit('getGiftsListScroll', []);
            this.totalPage = 0;
            this.currentPage = 1;
            this.isShowGiftModal = false;
        },
    },
    mounted() {
        this.getGiftInfo() // 判断礼物库存(调试时先注释)
        this.isScrollLodingShow = true;

        // this.initGiftsData() // test
        // this.getGiftsList() // test
        // this.isShowGiftModal = true // test
    },
};
</script>

<style scoped>
.choose-content {
    overflow-x: hidden;
    overflow-y: auto;
}

.choose-content > p {
    font-size: 34px;
    font-weight: 600;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.goods-list {
    margin-top: 30px;
    width: 240px;
}

.goods-list-img {
    width: 240px;
    height: 302px;
    background: #aaa;
    overflow: hidden;
}

.goods-list-img img {
    object-fit: cover;
}

.goods-list-img:hover img {
    animation: kfr-img 0.2s forwards ease;
}
@keyframes kfr-img {
    to {
        transform: scale(1.2);
    }
}

.goods-list-title {
    margin: 15px 0 20px 0;
    font-weight: 500;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.goods-list-btn button {
    height: 35px;
    line-height: 35px;
    width: 132px;
    font-size: 16px;
}

.comfirm-btn-hover {
    transition: background-color 0.2s;
}

.comfirm-btn-hover:hover {
    background-color: rgb(245, 185, 74);
}

.stock-btn {
    background: #ccc;
}

.modal-gift {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 100;
    overflow: hidden;
}

.modal-gift-body {
    width: 920px;
    height: 680px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -340px -460px;
    padding: 20px 50px;
    background: #fff;
    overflow: hidden;
}

.hidden {
    display: none;
}

/*适配手机*/

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .choose-content > p {
        font-size: 20px;
        padding-bottom: 10px;
    }
    .goods-list {
        width: 160px;
        margin-top: 20px;
    }
    .goods-list-img {
        width: 150px;
        height: 180px;
    }
    .goods-list-title {
        margin: 8px 0;
    }
    .goods-list-btn button {
        width: 75px;
        height: 23px;
        line-height: 23px;
        font-size: 12px;
    }
    .modal-gift-body {
        width: 90%;
        height: 600px;
        margin: -300px -45%;
        padding: 15px;
    }
    .phone-goods {
        display: flex;
        justify-content: center;
    }
}

.custom-input select {
    display: inline-block;
    width: 50%;
}
</style>
